<template>
  <!-- VISTA LISTAR -->
  <div>
    <template v-if="view === 'listar'">
      <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
        :custom-create-actions="[listTipoPersona, listBancos, listJuzgados, listEntidades, ListMacroFuente, listTipoDoc]" 
        @updateValues="setupUpdateValues">
        <!-- <component :is="childHeaderComponent" :auth-token="authToken"></component> -->
        <div class="flex flex-wrap gap-3 w-full sm:w-auto">
          <component :is="childHeaderComponent" :mainListCollectionData="mainListCollectionData" :auth-token="authToken"></component>
        </div>
      </HeaderComponent>
      
      <FilterRefactComponent  :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
          @updateValues="setupUpdateValues">
      </FilterRefactComponent>

      <TableComponent :entity="entity" :selected-data="selectedEmbargo" :table-columns="tableColumns"
        :collection-data="collectionData" 
        :custom-update-actions="[listTipoPersona, listBancos, listJuzgados, listEntidades, ListMacroFuente, listTipoDoc]"
        :custom-update-selected-data="customUpdateSelectedData" 
        :auth-token="authToken" 
        :list-api="listApi"
        :custom-update-collection-data="customUpdateCollectionData"
        @updateValues="setupUpdateValues">
        
        <template v-slot="{ data }">

        <!-- Mostrar el botón de Notificar solo si es pensionado o empleado -->
          <component 
            :is="childTableComponent" 
            :data="data" 
            :view="view"
            @data="(newData) => {
              updateValues({ data: newData }, this)
            } " 
            @updateValues="setupUpdateValues"
          ></component>

          <!-- Mostrar el botón de levantar medida, solo para contratistas -->
          <component 
            v-if="data.notificaciones"
            :is="childLevantarTableComponent" 
            :data="data" 
            :view="view"
            @data="(newData) => {
              updateValues({ data: newData }, this)
            } " 
            @updateValues="setupUpdateValues"
          ></component>

          <!-- Mostrar el botón de ingresos-->
          <component 
            v-if="data.notificaciones"
            :is="childIngresoTableComponent" 
            :data="data" 
            :view="view"
            @data="(newData) => {
              updateValues({ data: newData }, this)
            } " 
            @updateValues="setupUpdateValues"
          ></component>

          <!-- Mostrar el botón de Comprobantes-->
          <component 
            v-if="data.notificaciones"
            :is="childComprobanteTableComponent" 
            :data="data" 
            :view="view"
            @data="(newData) => {
              updateValues({ data: newData }, this)
            } " 
            @updateValues="setupUpdateValues"
          ></component>

          <!-- Mostrar el botón de egresos-->
          <component 
            v-if="data.notificaciones"
            :is="childEgresoTableComponent" 
            :data="data" 
            :view="view"
            @data="(newData) => {
              updateValues({ data: newData }, this)
            } " 
            @updateValues="setupUpdateValues"
          ></component>
          
          <!-- Mostrar el botón de certificaciones-->
          <component 
            v-if="data.notificaciones"
            :is="childCertificarTableComponent" 
            :data="data" 
            :view="view"
            @data="(newData) => {
              updateValues({ data: newData }, this)
            } " 
            @updateValues="setupUpdateValues"
          ></component>
          
        </template>


      </TableComponent>

      <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate" :optionalParams="queries"
        @updateValues="setupUpdateValues">
      </PaginateRefactComponent>
    </template>


    <template v-else-if="view === 'notificar_embargo'">
        <component 
          :is="childNotificarEmbargoComponent" 
          :load-data="loadDataEmbargo"
          :custom-update-value-data="customUpdateValueData" 
          :data="data" 
          :auth-token="authToken" 
          :entity=" { gender: 'f', value: 'notificación de embargo' }" 
          @updateValues="setupUpdateValues"  
          :customSaveData="customSaveData"
        >
        </component>
    </template>

    <template v-else-if="view === 'levantar_embargo'">
        <component 
          :is="childLevantarEmbargoComponent" 
          :load-data="loadDataEmbargo"
          :custom-update-value-data="customUpdateValueData" 
          :data="data" 
          :auth-token="authToken" 
          :entity=" { gender: 'm', value: 'levantamiento de embargo' }" 
          @updateValues="setupUpdateValues"  
          :customSaveData="customSaveData"
        >
        </component>
    </template>

    <template v-else-if="view === 'ingreso_embargo'">
        <component 
          :is="childIngresoEmbargoComponent" 
          :custom-update-value-data="customUpdateValueData" 
          :data="data" 
          :auth-token="authToken" 
          :entity=" { gender: 'm', value: 'Ingreso de embargo' }" 
          @updateValues="setupUpdateValues"  
          @watchList="listData"
          :customSaveData="customSaveData"
        >
        </component>
    </template>

    <template v-else-if="view === 'comprobante_embargo'">
        <component 
          :is="childContabilizarEmbargoComponent" 
          :load-data="loadDataEmbargo"
          :custom-update-value-data="customUpdateValueData" 
          :data="data" 
          :auth-token="authToken" 
          :entity=" { gender: 'm', value: 'Comprobante de Legalización' }" 
          @updateValues="setupUpdateValues"  
          :customSaveData="customSaveData"
        >
        </component>
    </template>

    <template v-else-if="view === 'egreso_embargo'">
        <component 
          :is="childEgresoEmbargoComponent" 
          :custom-update-value-data="customUpdateValueData" 
          :data="data" 
          :auth-token="authToken" 
          :entity=" { gender: 'm', value: 'Egreso de embargo' }" 
          @updateValues="setupUpdateValues"  
          @watchList="listData"
          :customSaveData="customSaveData"
        >
        </component>
    </template>

    <template v-else-if="view === 'certificacion_embargo'">
        <component 
          :is="childCertificarEmbargoComponent" 
          :custom-update-value-data="customUpdateValueData" 
          :data="data" 
          :auth-token="authToken" 
          :entity=" { gender: 'f', value: 'Certificación de embargo' }" 
          @updateValues="setupUpdateValues"  
          @watchList="listData"
          :customSaveData="customSaveData"
        >
        </component>
    </template>

    <!-- VISTA CREAR - ACTUALIZAR -->
    <template v-else>
      <CreateUpdateComponent 
        :view="view" 
        :paginate="paginate"  
        :selected-data="selectedEmbargo"
        :load-data="loadDataEmbargo"
        :entity="entity" 
        :auth-token="authToken" 
        :list-api="listApi" 
        :queries="queries"
        :custom-update-load-data="customUpdateLoadData" 
        @updateValues="setupUpdateValues"
      >
        <component  
          :view="view" 
          :is="childFormComponent" 
          :selected-data="selectedEmbargo"
          :collection-bancos="collectionBancos"
          :load-data="loadDataEmbargo" 
          :auth-token="authToken" 
          :custom-update-value-data="customUpdateValueData" 
          :collection-tipo-persona="collectionTipoPersona"
          :collection-juzgados="collectionJuzgados"
          :collection-entidades="collectionEntidades"
          :collection-tipo-doc="collectionTipoDoc"
          :collection-macro-fuente="collectionMacroFuente"
          @updateValues="setupUpdateValues"
        >
        </component>

      </CreateUpdateComponent>
    </template>
    
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { useAuth } from "@/components/auth/store/composables";
import { useLayoutMain, updateValues, listCollectionData } from "@/layouts/main";
import BotonNotificarEmbargoGobernacionComponent from "@/components/embargos/components/BotonNotificarEmbargoGobernacionComponent.vue";
import ChildHeaderComponent from "@/components/embargos/components/EmbargosGobernacionCargueMasivoComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import EmbargosGobernacionCrearActualizarComponent from "@/components/embargos/components/EmbargosGobernacionCrearActualizarComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import TableComponent from "@/layouts/main/TableComponent";
import NotificarEmbargoGobernacionComponent from '@/components/embargos/components/NotificarEmbargoGobernacionComponent'
import BotonLevantamientoEmbargoGobernacionComponent  from '@/components/embargos/components/BotonLevantamientoEmbargoGobernacionComponent'
import LevantarEmbargoGobernacionComponent from '@/components/embargos/components/LevantarEmbargoGobernacionComponent'
import BotonIngresoEmbargoGobernacionComponent from '@/components/embargos/components/BotonIngresoEmbargoGobernacionComponent'
import IngresosEmbargoGobernacionComponent from '@/components/embargos/components/IngresosEmbargoGobernacionComponent'
import BotonExitosoEmbargoPersonaComponent from '@/components/embargos/components/BotonExitosoEmbargoPersonaComponent'
import ExitososEmbargoPersonaComponent from '@/components/embargos/components/ExitososEmbargoPersonaComponent'
import BotonContabilidadEmbargoGobernacionComponent from '@/components/embargos/components/BotonContabilidadEmbargoGobernacionComponent'
import ContabilizarEmbargoGobernacionComponent from '@/components/embargos/components/ContabilizarEmbargoGobernacionComponent'
import BotonEgresoEmbargoGobernacionComponent from '@/components/embargos/components/BotonEgresoEmbargoGobernacionComponent'
import EgresosEmbargoGobernacionComponent from '@/components/embargos/components/EgresosEmbargoGobernacionComponent'
import CertificacionEmbargoGobernacionComponent from '@/components/embargos/components/CertificacionEmbargoGobernacionComponent'
import BotonCertificadoEmbargoGobernacionComponent from '@/components/embargos/components/BotonCertificadoEmbargoGobernacionComponent'
import { separateNumberByComma , copiaProfunda  } from "@/common/constants/functions";

export default {
  name: 'EmbargosGobernacion',
  components: {
    BotonNotificarEmbargoGobernacionComponent,
    ChildHeaderComponent,
    CreateUpdateComponent,
    EmbargosGobernacionCrearActualizarComponent,
    FilterRefactComponent,
    HeaderComponent,
    PaginateRefactComponent,
    TableComponent,
    NotificarEmbargoGobernacionComponent,
    BotonLevantamientoEmbargoGobernacionComponent,
    LevantarEmbargoGobernacionComponent,
    BotonIngresoEmbargoGobernacionComponent,
    IngresosEmbargoGobernacionComponent,
    BotonExitosoEmbargoPersonaComponent,
    ExitososEmbargoPersonaComponent,
    BotonContabilidadEmbargoGobernacionComponent,
    ContabilizarEmbargoGobernacionComponent,
    BotonEgresoEmbargoGobernacionComponent,
    EgresosEmbargoGobernacionComponent,
    CertificacionEmbargoGobernacionComponent,
    BotonCertificadoEmbargoGobernacionComponent
  },
  data: function () {
    return {
      dateRangePicker: undefined,
      childFormComponent: 'EmbargosGobernacionCrearActualizarComponent',
      childHeaderComponent: 'childHeaderComponent',
      childTableComponent: 'BotonNotificarEmbargoGobernacionComponent',
      childNotificarEmbargoComponent: 'NotificarEmbargoGobernacionComponent',
      childLevantarTableComponent: 'BotonLevantamientoEmbargoGobernacionComponent',
      childLevantarEmbargoComponent: 'LevantarEmbargoGobernacionComponent',
      childIngresoTableComponent: 'BotonIngresoEmbargoGobernacionComponent',
      childIngresoEmbargoComponent: 'IngresosEmbargoGobernacionComponent',
      childExitosoTableComponent: 'BotonExitosoEmbargoPersonaComponent',
      childExitosoEmbargoComponent: 'ExitososEmbargoPersonaComponent',
      childComprobanteTableComponent: 'BotonContabilidadEmbargoGobernacionComponent',
      childContabilizarEmbargoComponent: 'ContabilizarEmbargoGobernacionComponent',
      childEgresoTableComponent: 'BotonEgresoEmbargoGobernacionComponent',
      childEgresoEmbargoComponent: 'EgresosEmbargoGobernacionComponent',
      childCertificarTableComponent: 'BotonCertificadoEmbargoGobernacionComponent',
      childCertificarEmbargoComponent: 'CertificacionEmbargoGobernacionComponent',

      entity: { gender: 'm', value: 'Embargo' },
      Object: Object,
      title: 'Embargos contra la Gobernación del Tolima',
      updateValues: updateValues,
      tableColumns: {

        'numero_proceso': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Número Proceso'
        }, 
        'numero_oficio': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Número Oficio'
        },
        'fecha_oficio': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Fecha Oficio'
        },
        'numero_egreso': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Número Egreso'
        },
        'fecha_egreso': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Fecha Egreso'
        },
        'tipo_embargo': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Tipo de Embargo'
        },
        'titulo_deposito': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Título / Resolución'
        },
        'radicado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Radicado'
        },
        'juzgado.nombre_juzgado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre Juzgado'
        }, 
        'entidadCobroCoactivo.nombre_entidad': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre Entidad Cobro Coactivo'
        }, 
        'observaciones': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Observaciones'
        },
        'numero_auto_resolucion': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Numero Automandamiento / Resolución'
        },
        'demandante.primer_nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Primer Nombre Demandante',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'demandante.primer_apellido': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Primer Apellido Demandante',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'demandante.identificacion': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Identificación Demandante',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'cuentaBancaria.cuentasFuentesMacro.macroFuente.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Macro Fuente'
        },
        'valor': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'valor'
        },
        'valor_actual': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Saldo Actual',
          customCallbackClassValue: (valor_actual) => parseInt(valor_actual) > 0 ? 'text-red-500 font-extrabold	' : 'text-sky-500 font-extrabold	',
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const dataUser = ref(localStorage.getItem('user'));
    const idUser = JSON.parse(dataUser.value);
    const view = ref('listar');
    const data = ref({});
    const collectionData = ref([]);
    const collectionTipoPersona = ref([])
    const collectionJuzgados = ref([])
    const collectionEntidades = ref([])
    const collectionTipoDoc = ref([])
    const collectionMacroFuente = ref([]);
    const collectionBancos = ref([]);
    const customSaveData = ref([]);
    const authToken = ref(authStored.authToken);

    const selectedEmbargo = ref({
      id:'',
      numero_oficio: '',
      fecha_oficio: '',
      fecha_egreso: '',
      numero_egreso: '',
      radicado: '',
      radicado_tesoreria_numero: '',
      radicado_tesoreria_fecha: '',
      numero_proceso: '',
      numero_auto_resolucion: '',
      numero_embargo: '',
      titulo_deposito:'',
      primer_nombre_demandante: '',
      segundo_nombre_demandante: '',
      primer_apellido_demandante: '',
      segundo_apellido_demandante: '',
      identificacion_demandante: '',
      valor:'',
      tipo_identificacion_demandante: '',
      tipo_embargo: '',
      id_cuenta_bancaria: '',
      nombre_cuenta: '',
      cuenta_bancaria: '',
      demandante:'',
      cuentaBancaria: '',
      id_macro_fuente: '',
      id_fuente_concreta: '',
      valor_actual : '',
      id_juzgado: '',
      id_entidad_cobro: '',
      fuenteConcreta: '',
      nombre_fuente_concreta: '',
      id_cuenta_bancaria_new: '',
      observaciones: '',
      oficio_juridica: '',
      fecha_oficio_juridica: '',
      notificaciones: '',
      levantamientos: '',
      comprobantes: '',
    });
    const customQueries = ref({ 'id_usuario': idUser.id, 'estado': 1, });

    const loadDataEmbargo = ref({
      numero_oficio: '',
      fecha_oficio: '',
      fecha_egreso: '',
      numero_egreso: '',
      radicado: '',
      radicado_tesoreria_numero: '',
      radicado_tesoreria_fecha: '',
      numero_proceso: '',
      numero_auto_resolucion: '',
      numero_embargo: '',
      titulo_deposito:'',
      primer_nombre_demandante: '',
      segundo_nombre_demandante: '',
      primer_apellido_demandante: '',
      segundo_apellido_demandante: '',
      identificacion_demandante: '',
      valor:'',
      tipo_identificacion_demandante: '',
      tipo_embargo: '',
      id_cuenta_bancaria: '',
      nombre_cuenta: '',
      cuenta_bancaria: '',
      demandante:'',
      cuentaBancaria: '',
      id_macro_fuente: '',
      id_fuente_concreta: '',
      valor_actual : '',
      id_juzgado: '',
      id_entidad_cobro: '',
      fuenteConcreta: '',
      nombre_fuente_concreta: '',
      id_cuenta_bancaria_new: '',
      observaciones: '',
      oficio_juridica: '',
      fecha_oficio_juridica: '',
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_EMBARGOGOBERNACION_CREATE,
      list: process.env.VUE_APP_NEST_EMBARGOGOBERNACION_FINDALL,
      update: process.env.VUE_APP_NEST_EMBARGOGOBERNACION_UPDATE,
      updateState: process.env.VUE_APP_NEST_EMBARGOGOBERNACION_UPDATESTATE
    });

    const permissions = idUser.permissions;

    const customUpdateValueData = (key, value) => {
      // const fieldNumeric = ['embargo_id', 'egreso', 'identificacion', 'saldo_anterior', 'ajuste_embargo', 'reintegro', 'legalizacion', 'saldo_actual'];
      // if (fieldNumeric.includes(key)) return value !== '' ? Number(value) : value;
      return value;
    };

    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedEmbargo.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedEmbargo.value = updatedSelectedData;
    }

    const customUpdateLoadData = () => {
      for (const key in loadDataEmbargo.value) {
        let value = loadDataEmbargo.value[key];
        value = customUpdateValueData(key, value);
      }
    };

    const customUpdateCollectionData = () => {

      const copyCollectionData = copiaProfunda(collectionData.value);
      for (const copyData of copyCollectionData) {
        copyData['valor_actual'] = separateNumberByComma(copyData['valor_actual']);
        copyData['valor'] = separateNumberByComma(copyData['valor']);
      }
      return copyCollectionData;

    };

    const listBancos = async () => await listCollectionData(process.env.VUE_APP_NEST_BANCO_FINDALL, {'collectionBancos': collectionBancos}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

    const listTipoPersona = async () => await listCollectionData(process.env.VUE_APP_NEST_TIPO_PERSONA,  { 'collectionTipoPersona': collectionTipoPersona }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)

    const listJuzgados = async () => await listCollectionData(process.env.VUE_APP_NEST_JUZGADO_FINDALL,  { 'collectionJuzgados': collectionJuzgados }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)
    
    const listEntidades = async () => await listCollectionData(process.env.VUE_APP_NEST_ENTIDADCOBRO_FINDALL,  { 'collectionEntidades': collectionEntidades }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)

    const listTipoDoc = async () => await listCollectionData(process.env.VUE_APP_NEST_TIPODOCUMENTO_FINDALL,  { 'collectionTipoDoc': collectionTipoDoc }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)

    const {
        paginate,
        queries,
        setupUpdateValues,
        cleanLoadSelectedData,
        mainListCollectionData
      } = await useLayoutMain(view, collectionData, authToken, selectedEmbargo, loadDataEmbargo, listApi, customQueries.value);

    const listData = async () => {
      try {

        const res = await listCollectionData(
          process.env.VUE_APP_NEST_EMBARGOGOBERNACION_FINDALL,
          {'collectionData': collectionData.value},
          authToken.value,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true,
        );

        // Actualizar la referencia reactiva collectionData
        collectionData.value = res.data;

        } catch (error) {
        console.error('Error fetching data:', error);
        }
    }

    const updateQueries = queries.value;
    updateQueries['customQuery'] = customQueries.value;
    queries.value = updateQueries;

    const validatePermission = (permission) => {
      if(permissions.indexOf(permission) > 0){
        return true
      }
    }
    
    const ListMacroFuente = async () => await listCollectionData(process.env.VUE_APP_NEST_FUENTEMACRO_FINDALL, 
        {'collectionMacroFuente': collectionMacroFuente}, 
        authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

    return {
      view,
      collectionData,
      authToken,
      selectedEmbargo,
      loadDataEmbargo,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      customUpdateValueData,
      customUpdateSelectedData,
      customUpdateLoadData,
      customSaveData,
      dataUser,
      data,
      customUpdateCollectionData,
      customQueries,
      permissions,
      validatePermission,
      listTipoPersona,
      listJuzgados,
      listEntidades,
      listData,
      listBancos,
      ListMacroFuente,
      listTipoDoc,  
      // ListFuenteConcreta,
      collectionTipoPersona,
      collectionEntidades,
      collectionTipoDoc,
      collectionJuzgados,
      collectionBancos,
      collectionMacroFuente,
      // collectionFuenteConcreta,
      mainListCollectionData
    };
  },
  methods: {
    esFechaDeEsteAnio(fecha) {
      // Obtener el año actual
      const añoActual = new Date().getFullYear();

      // Obtener el año de la fecha de egreso
      const añoEgreso = new Date(fecha).getFullYear();

      // Comparar si la fecha pertenece al año actual
      return añoEgreso === añoActual;
    },
  },
}
</script>
<style scoped>
.title-embargo{
  width: 40% !important;
}
</style>